<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <!--begin::Title-->
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
          <!--end::Title-->
          <!--begin::Separator-->
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <!--end::Separator-->
          <!--begin::Breadcrumb-->

          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 "  v-for="(bread,key) in breadcrumbs" :key="key">

            <li v-if="key+1 !== breadcrumbs.length" class="breadcrumb-item text-muted">
              <router-link  :to="bread.path" class="text-muted text-hover-primary">{{  $t(bread.name) }}</router-link>
              <span class="bullet bg-gray-200 w-5px h-2px m-2"></span>
            </li>


            <!--end::Item-->
            <!--begin::Item-->
            <li v-else class="breadcrumb-item text-dark">{{ $t(bread.name) }}</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center gap-2 gap-lg-3">

          <!--begin::Filter menu-->
          <div class="m-0">
            <button  @click="$router.go(-1)" class="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder">
                                    <span class="svg-icon svg-icon-md">
                                        <i class="fas fa-backspace"></i>
                                    </span>{{$t("back")}}
            </button>
          </div>
          <!--end::Filter menu-->
        </div>
        <!--end::Actions-->
      </div>
    </div>

    <div class="post d-flex flex-column-fluid" id="kt_post">

      <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">

        <!-- Chargement de la commande : indicateur sur la page (et non sur le bouton de statut),
             sans montrer entre-temps la commande ouverte précédemment -->
        <div v-if="pageLoading" class="d-flex justify-content-center align-items-center py-20">
          <span class="spinner-border text-primary" role="status"></span>
          <span class="ms-3 text-gray-600">{{ $t('loading') }}</span>
        </div>

        <div class="row gy-5" v-show="!pageLoading">
          <!-- l'historique est fermé par défaut : la commande prend toute la largeur -->
          <div :class="showHistory ? 'col-lg-8 col-xxl-9' : 'col-12'">
            <!-- Card Principale -->
            <div class="card card-flush destockage-card ribbon ribbon-top ribbon-vertical">
              <!-- Ribbon Statut -->
              <div v-if="checkout.status" style="margin-bottom: 10px"
                   class="ribbon-label"
                   :class="`bg-${getStatusDetails(checkout.status).color}`">
                {{ getStatusDetails(checkout.status).label }}
              </div>

              <!-- Header avec statut -->
              <div class="card-header border-0 pt-6" style="margin-top: 15px">
                <div class="card-title d-flex align-items-center">
                  <div class="card-icon bg-light me-3">
                    <i class="bi bi-box-seam text-gray-600 fs-2"></i>
                  </div>
                  <div>
                    <h3 class="fw-bold mb-0">{{ $t('destockage.list') }}</h3>
                    <span class="text-muted fs-7">N° #{{ checkout?.number }}</span>
                  </div>
                </div>
                <div class="card-toolbar d-flex align-items-center gap-2">
                  <button class="btn btn-light-danger btn-sm"
                          @click="openInvoiceModal(checkout?.id)">
                    <i class="bi bi-file-earmark-pdf me-1"></i>{{ $t('shop.invoice') }}
                  </button>
                  <button v-if="checkout.status && checkout.status !== 'PENDING'"
                          class="btn btn-light btn-sm"
                          @click="openPreviewModal(checkout?.id)">
                    <i class="bi bi-file-earmark-pdf me-2"></i>{{ deliveryInfo?.type === 'RELAY' ? $t('destockage.download_pickup') : $t('destockage.download_delivery') }}
                  </button>
                  <button v-if="checkout.status === 'PENDING'"
                          @click.prevent="submitDestockageData"
                          :disabled="isLoading"
                          class="btn btn-primary btn-sm"
                          :data-kt-indicator="isLoading ? 'on' : ''">
                      <span class="indicator-progress">
                        {{ $t('loading') }}
                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    <span class="indicator-label">
                        <i class="bi bi-check2-circle me-2"></i>{{ $t('destockage.manage_stock') }}
                      </span>
                  </button>
                  <button v-else-if="nextStatus"
                          :disabled="isUpdateStatusLoading"
                          @click="advanceStatus"
                          class="btn btn-primary btn-sm">
                    <i class="bi bi-arrow-repeat me-2"></i>{{ nextStatusLabel }}
                  </button>
                  <div class="position-relative" ref="statusMenuRef">
                    <button type="button"
                            class="btn btn-icon btn-light btn-sm"
                            :title="$t('destockage.manual_status_change')"
                            @click="showManualStatusMenu = !showManualStatusMenu">
                      <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <div v-if="showManualStatusMenu"
                         class="dropdown-menu show position-absolute end-0 mt-1"
                         style="min-width: 240px; z-index: 105;">
                      <a href="#" class="dropdown-item" @click.prevent="openManualStatusChange">
                        {{ $t('destockage.manual_status_change') }}
                      </a>
                    </div>
                  </div>
                  <!-- historique : icône discrète, après le menu ⋮ -->
                  <button type="button"
                          class="btn btn-icon btn-light btn-sm"
                          :class="{ 'active': showHistory }"
                          :title="$t('destockage.histories')"
                          @click="toggleHistory">
                    <i class="bi bi-clock-history"></i>
                  </button>
                </div>
              </div>

              <div class="card-body pt-0">
                <!-- Informations en grille de cartes -->
                <div class="row g-2 mb-3">
                  <!-- Date -->
                  <div class="col-6 col-md-3">
                    <div class="info-card bg-light rounded p-2">
                      <div class="d-flex align-items-center">
                        <div class="info-icon bg-white border border-gray-200 rounded me-2">
                          <i class="bi bi-calendar3 text-gray-600"></i>
                        </div>
                        <div>
                          <span class="text-muted fs-8 d-block">{{ $t('destockage.date') }}</span>
                          <span class="fw-bold text-gray-800 fs-7">{{ checkout?.created_date }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Montant Total -->
                  <div class="col-6 col-md-3">
                    <div class="info-card bg-light rounded p-2">
                      <div class="d-flex align-items-center">
                        <div class="info-icon bg-white border border-gray-200 rounded me-2">
                          <i class="bi bi-cash-stack text-gray-600"></i>
                        </div>
                        <div>
                          <span class="text-muted fs-8 d-block">{{ $t('destockage.total') }}</span>
                          <span class="fw-bold text-gray-800 fs-7">{{ formattedLocalAmount(checkout?.amount_ttc) }} {{ currency }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Méthode de paiement -->
                  <div class="col-6 col-md-3">
                    <div class="info-card bg-light rounded p-2">
                      <div class="d-flex align-items-center">
                        <div class="info-icon bg-white border border-gray-200 rounded me-2">
                          <i class="bi bi-credit-card text-gray-600"></i>
                        </div>
                        <div>
                          <span class="text-muted fs-8 d-block">{{ $t('destockage.payment_method') }}</span>
                          <span class="fw-bold text-gray-800 fs-7">{{ getPaymentMethodStatusName(checkout?.payment_method).label }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Statut de paiement -->
                  <div class="col-6 col-md-3">
                    <div class="info-card bg-light rounded p-2">
                      <div class="d-flex align-items-center">
                        <div class="info-icon bg-white border border-gray-200 rounded me-2">
                          <i class="bi bi-wallet2 text-gray-600"></i>
                        </div>
                        <div>
                          <span class="text-muted fs-8 d-block">{{ $t('destockage.payment_status') }}</span>
                          <span class="fw-bold fs-7" :class="`text-${getPaymentStatusDetails(checkout?.payment_status).color || 'gray-800'}`">
                            {{ getPaymentStatusDetails(checkout?.payment_status).label || '-' }}
                          </span>
                          <!-- acompte payé à la commande (paiement à la livraison / au retrait) -->
                          <span v-if="depositAmount > 0 && checkout?.payment_status !== 'PAID'" class="text-primary fw-semibold fs-8 d-block">
                            {{ $t('deposit.paid_rest', { deposit: `${formattedLocalAmount(depositAmount)} ${currency}`, rest: `${formattedLocalAmount(amountToCollect)} ${currency}` }) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Précision laissée par le client à la commande -->
                <div v-if="checkout?.customer_note" class="alert alert-warning p-3 mb-3">
                  <div class="fw-bold mb-1"><i class="bi bi-chat-left-text me-2"></i>{{ $t('customer_note.title') }}</div>
                  <div style="white-space: pre-line">{{ checkout.customer_note }}</div>
                </div>

                <!-- Commande annulée après un acompte : remboursement à faire à la main -->
                <div v-if="depositAmount > 0 && checkout?.status === 'CANCELED'" class="alert alert-warning d-flex align-items-center p-3 mb-3">
                  <i class="bi bi-arrow-counterclockwise fs-3 me-2 text-warning"></i>
                  <span>{{ $t('deposit.to_refund', { deposit: `${formattedLocalAmount(depositAmount)} ${currency}`, reference: checkout?.payment_reference || '-' }) }}</span>
                </div>

                <!-- Remise au client : par code, ou sans code (gérant, avec motif) -->
                <div v-if="checkout?.handed_over_at" class="handover-info rounded p-3 mb-3" :class="checkout.handover_method === 'MANUAL' ? 'bg-light-warning' : 'bg-light-success'">
                  <i class="bi me-2" :class="checkout.handover_method === 'MANUAL' ? 'bi-exclamation-triangle text-warning' : 'bi-shield-check text-success'"></i>
                  <span class="fw-bold">{{ checkout.handover_method === 'MANUAL' ? $t('handover.done_manual') : (checkout.handover_method === 'CODE' ? $t('handover.done_code') : $t('handover.done')) }}</span>
                  <span class="text-muted"> — {{ formatHandoverDate(checkout.handed_over_at) }}<template v-if="checkout.handed_over_by">, {{ $t('handover.by', { name: checkout.handed_over_by }) }}</template></span>
                  <div v-if="checkout.collected_by" class="mt-1">{{ deliveryInfo?.type === 'RELAY' ? $t('handover.collected_by') : $t('handover.received_by') }} : <span class="fw-bold">{{ checkout.collected_by }}</span></div>
                  <div v-if="checkout.handover_reason" class="mt-1">{{ $t('handover.reason') }} : {{ checkout.handover_reason }}</div>
                </div>

                <!-- Livreur + Client + Livraison -->
                <div class="row g-2 mb-3">

                  <!-- Livreur -->
                  <div v-if="deliveryNote?.delivery_person || canChangeDriver" class="col-6 col-md-3">
                    <div class="p-2 border border-dashed border-gray-300 rounded h-100">
                      <span class="text-muted fs-8 d-flex align-items-center"><i class="bi bi-truck me-1"></i>{{ $t('destockage.delivery_user') }}
                        <span v-if="deliveryNote?.delivery_person?.type === 'EXTERNAL'" class="badge badge-light-warning fs-9 ms-1">{{ $t('destockage.external') }}</span>
                        <!-- commande en cours de livraison : le livreur peut être changé -->
                        <a v-if="canChangeDriver" href="#" class="ms-auto ps-2 text-primary" :title="deliveryNote?.delivery_person ? $t('destockage.change_driver') : $t('destockage.assign_driver_short')" @click.prevent="openChangeDriver">
                          <i class="bi bi-pencil-square fs-6 text-primary"></i>
                        </a>
                      </span>
                      <template v-if="deliveryNote?.delivery_person">
                        <span class="fw-semibold text-gray-800 fs-7 d-block">{{ deliveryNote.delivery_person.name }}</span>
                        <span v-if="deliveryNote.delivery_person.phone" class="text-muted fs-8">{{ deliveryNote.delivery_person.phone_code }} {{ deliveryNote.delivery_person.phone }}</span>
                      </template>
                      <span v-else class="text-muted fs-7 d-block">{{ $t('destockage.no_driver') }}</span>
                    </div>
                  </div>

                  <!-- Client -->
                  <div :class="deliveryNote?.delivery_person || canChangeDriver ? 'col-6 col-md-3' : 'col-6 col-md-4'">
                    <div class="p-2 border border-dashed border-gray-300 rounded h-100">
                      <span class="text-muted fs-8 d-block"><i class="bi bi-person me-1"></i>{{ $t('destockage.customer') }}</span>
                      <span class="fw-semibold text-gray-800 fs-7 d-block">{{ customerFullname || 'Inconnu' }}</span>
                      <span v-if="customerPhoneDisplay" class="text-muted fs-8">
                        {{ customerPhoneDisplay }}
                      </span>
                    </div>
                  </div>

                  <!-- Livraison -->
                  <div v-if="deliveryInfo" :class="deliveryNote?.delivery_person || canChangeDriver ? 'col-12 col-md-6' : 'col-12 col-md-8'">
                    <div class="p-2 border border-dashed border-gray-300 rounded h-100">
                      <span class="text-muted fs-8 d-block mb-1">
                        <i class="me-1" :class="deliveryInfo.type === 'RELAY' ? 'bi bi-geo-alt' : 'bi bi-house'"></i>
                        {{ deliveryInfo.type === 'RELAY' ? $t('destockage.relay_point') : $t('destockage.delivery_address') }}
                      </span>
                      <div v-if="checkout?.pickup_at || checkout?.pickup_asap" class="badge pickup-badge fs-7 mb-2">
                        <i class="fas fa-clock fs-8 me-1"></i>
                        {{ checkout.pickup_at ? formatPickup(checkout.pickup_at) : $t('destockage.pickup_asap') }}
                      </div>

                      <!-- ADDRESS : 2 colonnes -->
                      <template v-if="deliveryInfo.type === 'ADDRESS'">
                        <div class="row g-1">
                          <div class="col-6">
                            <span class="fw-semibold text-gray-800 fs-7 d-block">
                              {{ [deliveryInfo.firstname, deliveryInfo.lastname].filter(Boolean).join(' ') || '—' }}
                            </span>
                            <span v-if="deliveryInfo.phone" class="text-muted fs-8 d-block">
                              <!-- Numéro WhatsApp : ouvre la conversation au clic -->
                              <template v-if="deliveryInfo.is_whatsapp && whatsappUrl(deliveryInfo.phone, deliveryInfo.phone_code)">
                                <a :href="whatsappUrl(deliveryInfo.phone, deliveryInfo.phone_code)" target="_blank" rel="noopener"
                                   class="text-muted text-hover-primary" title="WhatsApp">
                                  <i class="bi bi-telephone me-1"></i>{{ deliveryInfo.phone?.startsWith('+') ? deliveryInfo.phone : (deliveryInfo.phone_code + ' ' + deliveryInfo.phone) }}
                                </a>
                                <a :href="whatsappUrl(deliveryInfo.phone, deliveryInfo.phone_code)" target="_blank" rel="noopener" title="WhatsApp">
                                  <i class="bi bi-whatsapp text-success ms-1"></i>
                                </a>
                              </template>
                              <template v-else>
                                <i class="bi bi-telephone me-1"></i>{{ deliveryInfo.phone?.startsWith('+') ? deliveryInfo.phone : (deliveryInfo.phone_code + ' ' + deliveryInfo.phone) }}
                              </template>
                            </span>
                          </div>
                          <div class="col-6">
                            <span v-if="deliveryInfo.quartier || deliveryInfo.city || deliveryInfo.country" class="text-gray-700 fs-8 d-block">
                              <i class="bi bi-pin-map me-1"></i>{{ [deliveryInfo.quartier, deliveryInfo.city, deliveryInfo.country].filter(Boolean).join(', ') }}
                            </span>
                            <span v-if="deliveryInfo.address && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(deliveryInfo.address.trim())" class="text-muted fs-8 d-block">
                              {{ deliveryInfo.address }}
                            </span>
                            <span v-if="deliveryInfo.point_de_repere" class="text-muted fs-8 d-block">
                              <i class="bi bi-info-circle me-1"></i>{{ deliveryInfo.point_de_repere }}
                            </span>
                            <span v-if="deliveryInfo.location_label && !deliveryInfo.quartier" class="text-gray-600 fs-8 d-block">
                              <i class="bi bi-geo me-1"></i>{{ deliveryInfo.location_label }}
                            </span>
                            <a v-if="deliveryInfo.latitude && deliveryInfo.longitude"
                               :href="`https://www.google.com/maps?q=${deliveryInfo.latitude},${deliveryInfo.longitude}`"
                               target="_blank"
                               class="btn btn-xs btn-light-primary mt-1 px-2 py-1 fs-8">
                              <i class="bi bi-map me-1"></i>{{ $t('destockage.view_on_map') }}
                            </a>
                          </div>
                        </div>
                      </template>

                      <!-- RELAY : 2 colonnes -->
                      <template v-else-if="deliveryInfo.type === 'RELAY'">
                        <div class="row g-1">
                          <div class="col-6">
                            <span class="fw-semibold text-gray-800 fs-7 d-block">{{ deliveryInfo.name }}</span>
                            <span v-if="deliveryInfo.phone" class="text-muted fs-8 d-block">
                              <i class="bi bi-telephone me-1"></i>{{ deliveryInfo.phone?.startsWith('+') ? deliveryInfo.phone : (deliveryInfo.phone_code + ' ' + deliveryInfo.phone) }}
                            </span>
                          </div>
                          <div class="col-6">
                            <span v-if="deliveryInfo.quartier || deliveryInfo.city || deliveryInfo.country" class="text-gray-700 fs-8 d-block">
                              <i class="bi bi-pin-map me-1"></i>{{ [deliveryInfo.quartier, deliveryInfo.city, deliveryInfo.country].filter(Boolean).join(', ') }}
                            </span>
                            <span v-if="deliveryInfo.address" class="text-muted fs-8 d-block">
                              {{ deliveryInfo.address }}
                            </span>
                            <span v-if="deliveryInfo.location_label && !deliveryInfo.city" class="text-gray-600 fs-8 d-block">
                              <i class="bi bi-geo me-1"></i>{{ deliveryInfo.location_label }}
                            </span>
                            <a v-if="deliveryInfo.latitude && deliveryInfo.longitude"
                               :href="`https://www.google.com/maps?q=${deliveryInfo.latitude},${deliveryInfo.longitude}`"
                               target="_blank"
                               class="btn btn-xs btn-light-primary mt-1 px-2 py-1 fs-8">
                              <i class="bi bi-map me-1"></i>{{ $t('destockage.view_on_map') }}
                            </a>
                          </div>
                        </div>
                      </template>

                    </div>
                  </div>

                </div>

                <!-- Récompense fidélité appliquée -->
                <div v-if="checkout.checkout_loyalty_rewards && checkout.checkout_loyalty_rewards.length" class="loyalty-reward-info mb-3">
                  <div v-for="reward in checkout.checkout_loyalty_rewards" :key="reward.id" class="d-flex align-items-center gap-2">
                    <i class="bi bi-gift text-success fs-4"></i>
                    <span class="fw-bold text-gray-800">{{ $t('loyalty.reward_section_title') }} :</span>
                    <span class="text-gray-700">{{ reward.label }}</span>
                    <span v-if="reward.reward_type === 'free_product'" class="badge badge-light-success">{{ $t('loyalty.free') }}</span>
                    <span v-else class="badge badge-light-success">-{{ reward.discount_amount }} {{ currency }}</span>
                  </div>
                </div>

                <!-- Tableau des produits -->
                <div class="products-section">
                  <h6 class="fw-bold text-gray-800 mb-2">
                    <i class="bi bi-bag-check me-2 text-gray-600"></i>{{ $t('destockage.products_list') || 'Liste des produits' }}
                  </h6>
                  <div class="table-responsive">
                    <table class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                      <thead>
                      <tr class="fw-bold text-muted bg-light">
                        <th class="ps-4 rounded-start">{{ $t("destockage.product") }}</th>
                        <th class="text-center" :class="{ 'rounded-end': !hasMultiplePlaces }">{{ $t("destockage.qty") }}</th>
                        <!-- un seul lieu de stock (une boutique, aucun magasin) : rien à choisir ni à afficher -->
                        <th v-if="hasMultiplePlaces">{{ $t("destockage.destockage") }}</th>
                        <th v-if="hasMultiplePlaces" class="pe-4 text-end rounded-end">{{ $t("destockage.action") }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(article, index) in checkout.checkout_product_with_quantity" :key="index">
                        <td class="ps-4">
                          <div class="d-flex align-items-center">
                            <div class="symbol symbol-40px me-3">
                              <div class="symbol-label bg-light">
                                <i class="bi bi-box text-gray-600"></i>
                              </div>
                            </div>
                            <div>
                              <span class="fw-bold text-gray-800 d-block">
                                {{ article.name }}
                                <span v-if="parseFloat(article.price) === 0" class="badge badge-light-success ms-1">
                                  <i class="bi bi-gift me-1"></i>{{ $t('loyalty.free') }}
                                </span>
                                <span v-if="article.checkout_bundle" class="badge badge-light-primary ms-1">
                                  <i class="bi bi-box-seam me-1"></i>{{ article.checkout_bundle.title }}
                                </span>
                              </span>
                              <span v-if="article.checkout_attributes" class="text-muted fs-7" v-html="generateAttributeHTML(article.checkout_attributes)"></span>
                              <!-- Options choisies par le client (accompagnement, suppléments) -->
                              <div v-if="article.options && article.options.length" class="d-flex flex-wrap gap-1 mt-1">
                                <span v-for="option in article.options" :key="option.id" class="badge badge-light-warning text-gray-800 fw-semibold">
                                  <span class="text-muted">{{ option.group_name }} :</span> {{ option.name }}<template v-if="Number(option.price) > 0"> · +{{ Number(option.price).toLocaleString() }}</template>
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <span class="qty-badge">{{ article.quantity }}</span>
                        </td>
                        <td v-if="hasMultiplePlaces">
                          <div class="d-flex flex-wrap gap-1">
                            <template v-for="destockPlace in getArticleDestockings(article.product_sale_element_id)" :key="destockPlace.id">
                              <span :style="destockPlace.shop_id ? 'background:rgba(54,153,255,0.15);color:#3699FF;padding:3px 6px;border-radius:4px;font-size:0.8em' : 'background:rgba(255,168,0,0.15);color:#FFA800;padding:3px 6px;border-radius:4px;font-size:0.8em'">
                                <i class="bi me-1" :class="destockPlace.shop_id ? 'bi-shop' : 'bi-building'"></i>
                                <span v-if="destockPlace.shop_id">{{ destockPlace.shop?.name }}: {{ $t('destockage.qty') }} {{ destockPlace.destock_quantity }}</span>
                                <span v-else>{{ destockPlace.store?.name }}: {{ $t('destockage.qty') }} {{ destockPlace.destock_quantity }}</span>
                              </span>
                            </template>
                          </div>
                        </td>
                        <td v-if="hasMultiplePlaces" class="pe-4 text-end">
                          <button v-if="checkout.status === 'PENDING'"
                                  class="btn btn-icon btn-light-primary btn-sm"
                                  @click="openEditModal(article, index)">
                            <i class="bi bi-pencil-square"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--end::Card-->
          </div>
          <div v-if="showHistory" class="col-lg-4 col-xxl-3">
            <!--begin::List Widget 5-->
            <div class="card card-xl-stretch history-card">
              <!--begin::Header-->
              <div class="card-header align-items-center border-0 min-h-50px pt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold fs-6 text-gray-900">{{$t("destockage.histories")}}</span>
                </h3>
                <button type="button" class="btn btn-sm btn-icon btn-light" :title="$t('button.close')" @click="toggleHistory">
                  <i class="bi bi-x-lg"></i>
                </button>

              </div>
              <!--end::Header-->

              <!--begin::Body-->
              <div class="card-body pt-2">
                <!--begin::Timeline-->
                <div class="timeline-label">
                  <div
                      v-for="(history, index) in statusHistories"
                      :key="history.id"
                      class="timeline-item"
                  >
                    <!-- Heure (label) -->
                    <div class="timeline-label fw-bold text-gray-800 fs-6">
                      {{ formatTime(history.changed_at) }}
                    </div>

                    <!-- Badge -->
                    <div class="timeline-badge">
                      <i class="fa fa-genderless text-primary fs-1"></i>
                    </div>

                    <!-- Contenu -->
                    <div class="timeline-content fw-semibold text-gray-800 ps-3">
                      <!-- changement de livreur -->
                      <div v-if="history.context === 'DELIVERY_PERSON'">
                        <i class="bi bi-truck text-info me-1"></i>{{ $t('destockage.driver_changed') }}
                        <template v-if="history.old"><strong class="text-warning">« {{ history.old }} »</strong> →</template>
                        <strong class="text-info">« {{ history.new }} »</strong>
                        {{ $t('destockage.by') }}
                        <strong>{{ history.author?.lastname || 'Inconnu' }} {{ history.author?.firstname || '' }}</strong>
                      </div>
                      <div v-else-if="!history.old_fr">
                        Nouvelle Commande  effectuée par le client :  <strong>
                        {{ history.author?.lastname ? (history.author.lastname + ' ' + (history.author.firstname || '')) : (customerFullname || 'Inconnu') }}
                      </strong>
                        <strong class="text-success">  « {{ history.new_fr }} »</strong>
                      </div>
                      <div v-else>
                        Statut changé de
                        <strong class="text-warning">« {{ history.old_fr }} »</strong>
                        à
                        <strong class="text-success">« {{ history.new_fr }} »</strong>
                        par
                        <strong>
                          {{ history.author?.lastname || 'Inconnu' }}
                          {{ history.author?.firstname || '' }}
                        </strong>
                        <div v-if="history.delivery_person" class="mt-1">
                          <i class="bi bi-truck text-info me-1"></i>
                          <span class="text-muted">Livreur assigné :</span>
                          <strong class="text-info">{{ history.delivery_person.name }}</strong>
                        </div>
                      </div>
                      <div class="text-muted fs-7">
                        {{ formatDate(history.changed_at) }}
                      </div>
                    </div>
                  </div>

                </div>
                <!--end::Timeline-->
              </div>
              <!--end: Card Body-->
            </div>
            <!--end: List Widget 5-->
          </div>
        </div>
      </div>

      <!-- Modal facture PDF -->
      <div class="modal fade" tabindex="-1" id="invoicePdfModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header py-3">
              <h5 class="modal-title">{{ $t('shop.invoice') }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeInvoiceModal"></button>
            </div>
            <div class="modal-body p-0" style="height:80vh">
              <div v-if="invoicePdfLoading" class="d-flex align-items-center justify-content-center h-100">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
              <iframe v-else-if="invoicePdfUrl" :src="invoicePdfUrl" class="w-100 h-100 border-0"></iframe>
            </div>
            <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" @click="closeInvoiceModal">{{ $t('button.close') }}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="editModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('destockage.validation') }} </h5>
              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                          fill="currentColor"/>
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                          fill="currentColor"/>
                                </svg>
                                </span>
                <!--end::Svg Icon-->
              </div>

              <!--end::Close-->
            </div>

            <div class="modal-body">
              <!--begin:Form-->
              <form id="kt_modal_new_target_form" @submit.prevent="createDestockageData" class="form" >

                <div class="info-card bg-light rounded p-3 mb-4">
                  <div class="mb-2">
                    <span class="text-muted fs-8 d-block">{{ $t('destockage.product') }}</span>
                    <span class="fw-bold text-gray-800 fs-6">
                      {{ formEditModal.name }}
                      <template v-if="formEditModal.attributes && formEditModal.attributes.length">
                        || <span v-html="generateAttributeHTML(formEditModal.attributes)"></span>
                      </template>
                    </span>
                  </div>
                  <div>
                    <span class="text-muted fs-8 d-block">{{ $t('destockage.qty') }}</span>
                    <span class="fw-bold text-gray-800 fs-6">{{ formEditModal?.quantity }}</span>
                  </div>
                </div>

                <div class="card-body p-0">
                  <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_commandes" style="margin-top: 13px !important; cursor:pointer">
                    <thead>
                    <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                      <th> {{$t("destockage.destockagePlace")}}</th>
                      <th> {{$t("destockage.qtyLocked")}}</th>
                      <th> {{$t("destockage.qtyToTake")}}</th>
                      <th> {{$t("destockage.qtyAvailable")}}</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="(destockageSource,index) in formEditModal?.destockage" >
                      <td>{{destockageSource.place_name}}</td>
                      <td>{{destockageSource.destock_qty}}</td>
                      <td>
                        <input type="number" @keypress="onlyNumber" required class="form-control form-control-solid"  v-model="destockageSource.quantity" />
                      </td>
                      <td>
                            <span >
                                  {{ destockageSource.totalQuantity }}
                            </span>
                      </td>
                    </tr>
                    <tr class="text-center fw-bold">
                      <td colspan="4">
                        {{ $t('destockage.otherPlace') }}
                        <button class="btn btn-sm btn-primary ms-3" :disabled="!availableOtherPlaces.length" @click.prevent="addOtherDestockingPlace">  <i class="fas fa-plus"></i> {{ $t('button.add') }} </button>
                      </td>
                    </tr>
                    <tr v-for="(otherPlace, index) in otherPlaces" :key="index">
                      <td>
                        <Select2
                            containerClass="col-md-12"
                            :name="'promotionsProducts'+index"
                            labelClass="form-label fs-6 fw-bolder text-black"
                            :multiple="false"
                            :selectClass="'form-select form-control-lg form-control-solid form-select-solid h-45px'"
                            :isRequired="false"
                            v-model="otherPlace.place_id"
                            @update:modelValue="(val) => selectOtherPlace(otherPlace, val)"
                        >
                          <option  v-for="(shop, index) in getOtherShops(checkoutShops.filter(el => !formEditModal.destockage.some(pl => pl.place_id === el.id)), otherPlaces, index)" :key="index"
                                   :value="shop.id"> {{ shop.name }}
                          </option>
                        </Select2>
                      </td>
                      <td>
                        <input type="number" @keypress="onlyNumber" required class="form-control form-control-solid"  v-model="formEditModal.quantity" />
                      </td>
                      <td>
                        <!--                                        <input type="number" @keypress="onlyNumber" required class="form-control form-control-solid"  v-model="numberLocked[index].qtyToTake" />-->
                        <input type="number" @keypress="onlyNumber" required class="form-control form-control-solid"  v-model="otherPlace.quantity" />
                      </td>
                      <td>
                            <span>
                                  {{ otherPlace.totalAvailableQuantity }}
                            </span>
                      </td>
                      <td>
                        <button class="btn btn-sm btn-secondary" @click.prevent="removeOtherDestockingPlace(index)"> <i class="fas fa-trash-alt"></i> </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                  <button :disabled="isLoading"
                          class="btn btn-sm btn-primary fw-bolder"
                          type="submit"
                          :data-kt-indicator="isLoading ? 'on' : ''"
                  >
                                <span class="indicator-progress">
                                  {{  $t('loading') }}
                                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                    <span class="indicator-label">{{ $t('button.save') }}</span>
                  </button>
                </div>
              </form>
              <!--end:Form-->
            </div>

          </div>
        </div>
      </div>
    </div>



    <div class="modal fade" id="changeStatusModal" data-backdrop="static" tabindex="-1" role="dialog"
         aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <form  @submit.prevent="updateCheckoutStatusData" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ reassignMode ? $t('destockage.change_driver') : $t('destockage.changement_status') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                          transform="rotate(-45 6 17.3137)" fill="currentColor" />
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                          transform="rotate(45 7.41422 6)" fill="currentColor" />
                                </svg>
                            </span>
              </div>
            </div>
            <div class="modal-body">
              <!-- Statuts en tuiles cliquables : sobres (une pastille de couleur seulement), le choix
                   est mis en avant à la couleur principale ; le statut actuel est grisé -->
              <div v-if="!reassignMode" class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-3 required">{{ $t('destockage.status') }}</label>
                <div class="status-grid">
                  <button
                      v-for="status in checkoutStatus"
                      :key="status.value"
                      type="button"
                      class="status-tile"
                      :class="{ 'is-selected': formUpdateStatusData.status === status.value }"
                      :disabled="status.value === checkout?.status"
                      @click="formUpdateStatusData.status = status.value"
                  >
                    <span class="status-dot" :class="'bg-' + getStatusDetails(status.value).color"></span>
                    <span class="status-label">{{ getStatusDetails(status.value).label }}</span>
                    <span v-if="status.value === checkout?.status" class="status-current">{{ $t('destockage.current_status') }}</span>
                    <i v-else-if="formUpdateStatusData.status === status.value" class="bi bi-check-circle-fill status-check"></i>
                  </button>
                </div>
              </div>

              <div v-if="formUpdateStatusData.status === 'SHIPPED' || reassignMode" class="mb-6">
                <!-- Checkbox assignation livreur (inutile pour un changement de livreur) -->
                <div v-if="!reassignMode" class="form-check form-switch mb-4">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="assignDeliveryCheck"
                      v-model="assignDelivery"
                  />
                  <label class="form-check-label fs-6 fw-bold ms-2" for="assignDeliveryCheck">
                    {{ $t('destockage.assign_delivery_user') || 'Assigner un livreur' }}
                  </label>
                </div>

                <!-- Choix interne / externe — affiché seulement si checkbox cochée -->
                <div v-if="assignDelivery || reassignMode">
                  <div class="btn-group w-100 mb-4" role="group">
                    <button type="button"
                            class="btn btn-sm"
                            :class="formUpdateStatusData.delivery_type === 'INTERNAL' ? 'btn-primary' : 'btn-light'"
                            @click="formUpdateStatusData.delivery_type = 'INTERNAL'">
                      {{ $t('destockage.internal_driver') }}
                    </button>
                    <button type="button"
                            class="btn btn-sm"
                            :class="formUpdateStatusData.delivery_type === 'EXTERNAL' ? 'btn-primary' : 'btn-light'"
                            @click="formUpdateStatusData.delivery_type = 'EXTERNAL'">
                      {{ $t('destockage.external_driver') }}
                    </button>
                  </div>

                  <!-- Livreur interne : compte existant -->
                  <div v-if="formUpdateStatusData.delivery_type === 'INTERNAL'" class="d-flex flex-column fv-row">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <label class="d-flex align-items-center fs-6 fw-bold mb-0">
                        {{ $t('destockage.delivery_user') || 'Livreur' }}
                      </label>
                      <button
                          type="button"
                          class="btn btn-sm btn-icon btn-light-primary"
                          style="width:32px;height:32px"
                          :title="$t('user.create')"
                          @click="openCreateDelivererModal"
                      >
                        <i class="bi bi-plus fs-4"></i>
                      </button>
                    </div>
                    <Select2
                        v-model="formUpdateStatusData.delivery_user_id"
                        :isRequired="false"
                        :multiple="false"
                        :placeholderText="$t('destockage.select_delivery_user') || 'Sélectionner un livreur'"
                        :selectClass="'form-select form-select-solid kt_select2'"
                        containerClass=""
                        name="delivery_user"
                        parentId="#changeStatusModal"
                    >
                      <option
                          v-for="user in deliveryUsers"
                          :key="user.id"
                          :value="user.id"
                      >
                        {{ user.fullname }}
                      </option>
                    </Select2>
                  </div>

                  <!-- Livreur externe : pas de compte -->
                  <div v-else class="d-flex flex-column fv-row">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <label class="d-flex align-items-center fs-6 fw-bold mb-0">
                        {{ $t('destockage.external_driver') }}
                      </label>
                      <button
                          type="button"
                          class="btn btn-sm btn-icon btn-light-primary"
                          style="width:32px;height:32px"
                          :title="$t('destockage.new_external_driver')"
                          @click="toggleNewExternalPerson"
                      >
                        <i class="bi fs-4" :class="showNewExternalPerson ? 'bi-dash' : 'bi-plus'"></i>
                      </button>
                    </div>
                    <Select2
                        v-if="externalDeliveryPersons.length"
                        v-model="selectedExternalDeliveryPersonId"
                        :isRequired="false"
                        :multiple="false"
                        :placeholderText="$t('destockage.select_external_driver')"
                        :selectClass="'form-select form-select-solid kt_select2'"
                        containerClass=""
                        name="external_delivery_person"
                        parentId="#changeStatusModal"
                    >
                      <option
                          v-for="person in externalDeliveryPersons"
                          :key="person.id"
                          :value="person.id"
                      >
                        {{ person.name }}{{ person.phone ? ' — ' + person.phone : '' }}
                      </option>
                    </Select2>
                    <div v-else-if="!showNewExternalPerson" class="text-muted fs-8">
                      {{ $t('destockage.no_external_driver_yet') }}
                    </div>

                    <!-- Nouveau livreur externe : saisi ici, sous la liste (plus de fenêtre dans la fenêtre) -->
                    <div v-if="showNewExternalPerson" class="border border-dashed rounded p-4 mt-3">
                      <div class="fw-bold fs-7 text-gray-800 mb-3">{{ $t('destockage.new_external_driver') }}</div>
                      <!-- nom et téléphone côte à côte (l'un sous l'autre sur petit écran) -->
                      <div class="row g-3 mb-3">
                      <div class="col-sm-6">
                        <label class="form-label fs-7 required">{{ $t('destockage.external_driver_name') }}</label>
                        <input type="text" class="form-control form-control-sm form-control-solid"
                               v-model="newExternalPerson.name" :placeholder="$t('destockage.external_driver_name')" />
                      </div>
                      <InputTel
                          name="new-external-driver-phone"
                          :label="$t('destockage.external_driver_phone')"
                          containerClass="col-sm-6"
                          labelClass="form-label fs-7"
                          inputClass="form-control form-control-sm form-control-solid"
                          v-model:phone="newExternalPerson.phone"
                          v-model:phone-code="newExternalPerson.phone_code"
                          :placeholder="$t('enter_phone')"
                          :isRequired="false"
                      />
                      </div>
                      <div class="d-flex justify-content-end gap-2">
                        <button type="button" class="btn btn-sm btn-light" @click="toggleNewExternalPerson">{{ $t('button.cancel') }}</button>
                        <button type="button" class="btn btn-sm btn-primary" :disabled="savingExternalPerson || !newExternalPerson.name.trim()" @click="saveNewExternalPerson">
                          <span v-if="savingExternalPerson" class="spinner-border spinner-border-sm me-1"></span>
                          {{ $t('destockage.add_external_driver') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close')
                }}</button>
              <button :disabled="isUpdateStatusLoading || (!reassignMode && !formUpdateStatusData.status)"
                      class="btn btn-sm btn-primary fw-bolder"
                      type="submit"
                      :data-kt-indicator="isUpdateStatusLoading ? 'on' : ''"
              >
                            <span class="indicator-progress">
                            {{  $t('loading') }}
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                <span class="indicator-label">{{ $t('button.save') }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="showModal" class="modal-backdrop">
      <div class="modal-container">
        <button @click="closeModal" class="close-btn">&times;</button>
        <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            width="100%"
            height="700px"
        />

      </div>
    </div>

    <CreateUserModal
        ref="createUserModalRef"
        modal-id="createDelivererModal"
        @user-created="onDelivererCreated"
    />

    <CreateExternalDeliveryPersonModal
        ref="createExternalPersonModalRef"
        modal-id="createExternalDeliveryPersonModal"
        @person-saved="onExternalPersonSaved"
    />

    <!-- passage en « Livrée » : code de remise du client -->
    <HandoverCodeModal
        v-model:show="showHandover"
        :checkout-id="checkout?.id"
        :pickup="deliveryInfo?.type === 'RELAY'"
        :can-override="$can('delivery_handover_override')"
        :amount-to-collect="checkout?.payment_status !== 'PAID' && amountToCollect > 0 ? `${formattedLocalAmount(amountToCollect)} ${currency}` : ''"
        :submit="submitHandover"
    />

  </div>
</template>

<script setup>
import {useStore} from "vuex";
import { whatsappUrl } from "@/helpers/whatsapp";
import {useRoute, useRouter} from "vue-router";
import {computed, nextTick, onMounted, onUnmounted, onUpdated, ref, watch} from "vue";
import { BASE_URL } from "@/services/api";
import {formattedLocalAmount} from "@/mixins/Helper.vue";
import Input from "@/components/Input.vue";
import Select2 from '@/components/Select2.vue'
import CreateUserModal from '@/components/modals/users/CreateUserModal.vue'
import CreateExternalDeliveryPersonModal from '@/components/modals/delivery/CreateExternalDeliveryPersonModal.vue'
import HandoverCodeModal from '@/components/modals/delivery/HandoverCodeModal.vue'
import InputTel from '@/components/InputTel.vue'
import i18n from "@/plugins/i18n";
import * as ecommerceTypes from "@/store/modules/ecommerce/mutation-types";

const store = useStore()
const route = useRoute()
const router = useRouter()

const locale = computed(() => i18n.global.locale)
const checkout = computed(() => store.getters['ecommerce/getCurrentCheckout'])
// acompte payé à la commande ; le reste est encaissé à la remise
const depositAmount = computed(() => Number(checkout.value?.deposit_amount) || 0)
const amountToCollect = computed(() => Math.max(0, (Number(checkout.value?.amount_ttc) || 0) - depositAmount.value))
const deliveryInfo = computed(() => store.getters['ecommerce/getCurrentDeliveryInfo'])
// heure de retrait choisie par le client, affichée dans l'heure locale du navigateur
// « Retrait aujourd'hui à 12:30 », « Retrait demain à 12:30 », sinon « Retrait le ven. 03/10 à 12:30 »
const formatPickup = (value) => {
  const d = new Date(value)
  const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
  const dayDiff = Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - new Date(new Date().setHours(0, 0, 0, 0))) / 86400000)
  if (dayDiff === 0) return i18n.global.t('destockage.pickup_today', { time })
  if (dayDiff === 1) return i18n.global.t('destockage.pickup_tomorrow', { time })
  return i18n.global.t('destockage.pickup_at', { date: d.toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit' }) + ' à ' + time })
}
const getCurrentProductPlaces = computed(() => store.getters['ecommerce/getCurrentProductPlaces'])
const checkoutDestockings = computed(() => checkout.value?.destockings ?? [])

const customerFullname = computed(() => {
  const c = checkout.value
  if (!c) return ''
  if (c.customer?.fullname) return c.customer.fullname
  const guestName = [c.guest_firstname, c.guest_lastname].filter(Boolean).join(' ')
  return guestName || ''
})

const customerPhoneDisplay = computed(() => {
  const c = checkout.value
  if (!c) return ''
  const phone = c.customer?.phone || c.guest_phone
  const phoneCode = c.customer?.phone_code || c.guest_phone_code
  if (!phone) return ''
  return phone.startsWith('+') ? phone : `${phoneCode || ''} ${phone}`.trim()
})

const checkoutStatus = computed(() => store.getters['core/getCheckoutStatus'])

// Prochaine étape logique du statut, selon le mode de livraison :
//  - retrait (RELAY) : traitée → prête → retirée (pas d'étape SHIPPED) ;
//  - livraison : traitée → expédiée → livrée. « Prête » n'y est plus proposée (un clic de plus
//    pour le commerçant, et un message ambigu pour un client qui attend d'être livré) ; elle
//    reste accessible par le menu des statuts, et mène alors à l'expédition.
const nextStatus = computed(() => {
  const status = checkout.value?.status
  const deliveryType = deliveryInfo.value?.type
  if (status === 'PROCESSED') return deliveryType === 'RELAY' ? 'READY' : 'SHIPPED'
  if (status === 'READY') return deliveryType === 'RELAY' ? 'DELIVERED' : 'SHIPPED'
  if (status === 'SHIPPED') return 'DELIVERED'
  return null
})

const nextStatusLabel = computed(() => {
  const deliveryType = deliveryInfo.value?.type
  if (nextStatus.value === 'READY') return i18n.global.t('destockage.mark_ready')
  if (nextStatus.value === 'SHIPPED') return i18n.global.t('destockage.mark_shipped')
  if (nextStatus.value === 'DELIVERED') {
    return deliveryType === 'RELAY' ? i18n.global.t('destockage.mark_picked_up') : i18n.global.t('destockage.mark_delivered')
  }
  return ''
})
const paymentStatus = computed(() => store.getters['payments/getPaymentStatusEnums'])
const paymentMethods = computed(() => store.getters['payments/getPaymentEnums'])

const hasMultiplePlaces = computed(() => {
  const shops  = store.getters['shop/getShops']  ?? []
  const stores = store.getters['store/getStores'] ?? []
  return (shops.length + stores.length) > 1
})

const formUpdateStatusData = ref({
  status: '',
  checkout_id: route?.params.id,
  delivery_type: 'INTERNAL',
  delivery_user_id: '',
  delivery_person_name: '',
  delivery_person_phone: '',
  delivery_person_phone_code: ''
})
const assignDelivery = ref(false)
const deliveryUsers = ref([])
const externalDeliveryPersons = ref([])
const selectedExternalDeliveryPersonId = ref('')
const showManualStatusMenu = ref(false)
const statusMenuRef = ref(null)
const createUserModalRef = ref(null)
const createExternalPersonModalRef = ref(null)
const currency = ref('')
const title = ref("navigation.e-commerce")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.store.dashboard',
    path: '/admin/dashboard'
  },
  {
    name: 'e-commerce.commandeList',
    path: '/admin/ecommerce/orders'
  },
  {
    name: 'destockage.title',
    path: ''
  },
])
const isLoading = ref(false)
const pageLoading = ref(true)
const isUpdateStatusLoading = ref(false)
const checkoutShops = ref([])
const statusHistories = ref([])

// panneau Historique : fermé par défaut, choix gardé sur ce navigateur
const showHistory = ref((() => { try { return localStorage.getItem('order_history_open') === '1' } catch (e) { return false } })())
function toggleHistory() {
  showHistory.value = !showHistory.value
  try { localStorage.setItem('order_history_open', showHistory.value ? '1' : '0') } catch (e) { /* stockage indisponible */ }
}
const deliveryNote = ref({})
const formEditModal = ref({
  index: null,
  product_sale_element_id: "",
  quantity: 0,
  destock_qty: 0,
  destockage: [],
})
const formDestockData = ref({
  checkout_id: "",
  checkoutData: []
})
const numberLocked = ref([])
const otherPlaces = ref([])

const showModal = ref(false)
const pdfUrl = ref(null)
const invoicePdfUrl = ref(null)
const invoicePdfLoading = ref(false)

function getStatusDetails(status) {
  const statusObj = checkoutStatus.value.find(option => option.value === status)
  if (!statusObj) return { label: '', color: 'primary' }
  return {
    label: locale.value === 'fr' ? statusObj.fr : statusObj.en,
    color: statusObj.color || 'primary'
  }
}

function getPaymentStatusDetails(status) {
  const statusObj = paymentStatus.value.find(option => option.value === status)
  if (!statusObj) return { label: '', color: 'primary' }
  return {
    label: locale.value === 'fr' ? statusObj.fr : statusObj.en,
    color: statusObj.color || 'primary'
  }
}

function getPaymentMethodStatusName(status) {
  const statusObj = paymentMethods.value.find(option => option.value === status)
  if (!statusObj) return { label: '', color: 'primary' }
  return {
    label: locale.value === 'fr' ? statusObj.fr : statusObj.en,
    color: statusObj.color || 'primary'
  }
}
const openInvoiceModal = async (checkoutId) => {
  if (!checkoutId) return

  const isPWA    = window.matchMedia('(display-mode: standalone)').matches
  const isMobile = window.innerWidth <= 767

  // Sur mobile/PWA : l'iframe blob ne s'affiche pas → téléchargement direct
  if (isPWA || isMobile) {
    try {
      const response = await axios({
        url: BASE_URL + '/get/pdf/checkout/' + checkoutId,
        method: 'GET',
        responseType: 'blob',
        headers: { Authorization: 'Bearer ' + Ls.get('auth.token') }
      })
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url  = window.URL.createObjectURL(blob)
      const a    = document.createElement('a')
      a.href     = url
      a.download = `facture-${checkoutId}.pdf`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(() => window.URL.revokeObjectURL(url), 1500)
    } catch {
      window.toastr['error'](i18n.global.t('error'))
    }
    return
  }

  // Desktop : afficher dans le modal iframe
  invoicePdfUrl.value = null
  invoicePdfLoading.value = true
  $('#invoicePdfModal').modal('show')
  try {
    const response = await axios({
      url: BASE_URL + '/get/pdf/checkout/' + checkoutId,
      method: 'GET',
      responseType: 'blob',
      headers: { Authorization: 'Bearer ' + Ls.get('auth.token') }
    })
    const blob = new Blob([response.data], { type: 'application/pdf' })
    invoicePdfUrl.value = window.URL.createObjectURL(blob)
  } catch {
    $('#invoicePdfModal').modal('hide')
    window.toastr['error'](i18n.global.t('error'))
  } finally {
    invoicePdfLoading.value = false
  }
}

const closeInvoiceModal = () => {
  if (invoicePdfUrl.value) {
    window.URL.revokeObjectURL(invoicePdfUrl.value)
    invoicePdfUrl.value = null
  }
}

const openPreviewModal = async (checkoutId) => {
  try {
    const url = await store.dispatch('ecommerce/previewDeliveryReceipt', checkoutId)
    pdfUrl.value = url
    showModal.value = true
  } catch (e) {
    console.error('Erreur pour afficher le PDF', e)
  }
}

const closeModal = () => {
  showModal.value = false
  pdfUrl.value = null

}
function openCreateDelivererModal() {
  createUserModalRef.value?.open()
}

async function onDelivererCreated(user) {
  deliveryUsers.value.push(user)
  await nextTick()
  formUpdateStatusData.value.delivery_type = 'INTERNAL'
  formUpdateStatusData.value.delivery_user_id = String(user.id)
  initializeSelect()
}

function openCreateExternalPersonModal() {
  createExternalPersonModalRef.value?.open()
}

// Nouveau livreur externe saisi directement sous la liste, sans ouvrir une autre fenêtre
const showNewExternalPerson = ref(false)
const savingExternalPerson = ref(false)
const emptyExternalPerson = () => ({ name: '', phone: '', phone_code: '' })
const newExternalPerson = ref(emptyExternalPerson())

function toggleNewExternalPerson() {
  showNewExternalPerson.value = !showNewExternalPerson.value
  newExternalPerson.value = emptyExternalPerson()
}

async function saveNewExternalPerson() {
  savingExternalPerson.value = true
  try {
    const response = await store.dispatch('ecommerce/createExternalDeliveryPerson', newExternalPerson.value)
    const person = response?.data?.delivery_person
    if (person) {
      window.toastr['success'](i18n.global.t('destockage.external_driver_created'))
      showNewExternalPerson.value = false
      newExternalPerson.value = emptyExternalPerson()
      // ajouté à la liste et sélectionné, comme avec l'ancienne fenêtre
      await onExternalPersonSaved({ person })
    }
  } catch {
    // message affiché par l'intercepteur axios global (ex. doublon)
  } finally {
    savingExternalPerson.value = false
  }
}

async function onExternalPersonSaved({ person }) {
  externalDeliveryPersons.value.push(person)
  await nextTick()
  selectedExternalDeliveryPersonId.value = String(person.id)
  initializeSelect()
}


function formatTime(dateString) {
  const date = new Date(dateString)
  return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
}

function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

const getArticleDestockings = (productSaleElementId) => {
  return (checkout.value?.destockings ?? []).filter(d => d.product_sale_element_id === productSaleElementId)
}

watch(() => checkout.value, (value) => {
  if(value && value.destockings) {
    formDestockData.value.checkout_id = value.id
    let checkoutData = []
    value.destockings.forEach(el => {
      checkoutData.push({
        product_sale_element_id: el.product_sale_element_id,
        shop_id: el.shop_id,
        shop_name: el?.shop?.name,
        store_id: el.store_id,
        store_name: el?.store?.name,
        destock_quantity:  el.destock_quantity
      })
    })
    formDestockData.value.checkoutData = checkoutData
  }
}, { immediate: true })

watch(() => getCurrentProductPlaces.value, (value) => {
  if(value) {
    checkoutShops.value =  [
      ...value.shops.map(shop => ({ ...shop, isShop: true })),
      ...value.stores.map(store => ({ ...store, isShop: false }))
    ]
  }
})

// Boutiques/entrepôts pas déjà utilisés dans la répartition (ni dans les
// lignes existantes, ni dans les lignes "autre lieu" déjà ajoutées) — s'il
// n'en reste aucun, il n'y a plus rien à ajouter.
const availableOtherPlaces = computed(() => {
  const usedIds = new Set([
    ...formEditModal.value.destockage.map(d => d.place_id),
    ...otherPlaces.value.map(p => p.place_id).filter(Boolean),
  ])
  return checkoutShops.value.filter(place => !usedIds.has(place.id))
})

const openEditModal = async (article,index) => {
  await store.dispatch('ecommerce/loadPlacesWithProduct', article.product_sale_element_id)

  formEditModal.value.index = index;
  formEditModal.value.product_sale_element_id = article.product_sale_element_id;
  formEditModal.value.name = article.name;
  formEditModal.value.attributes = article.checkout_attributes;
  formEditModal.value.quantity = article.quantity;
  formEditModal.value.destockage = []
  // Sinon les lieux ajoutés pour un article restaient affichés (et
  // comptaient dans les lieux "déjà utilisés") en éditant un autre article.
  otherPlaces.value = []
  const productPlaces = getCurrentProductPlaces.value
  const destockData = checkout.value.destockings.filter(destockPlace => destockPlace.product_sale_element_id === article.product_sale_element_id);
  for(const data of destockData) {
    formEditModal.value.destockage.push({
      place_id: !!data.shop_id ? data.shop.id : data.store.id,
      place_name: !!data.shop_id ? data.shop.name : data.store.name,
      isShop: !!data.shop_id,
      destock_qty: data.checkout_quantity,
      quantity: !!data.shop_id
          ? formDestockData.value.checkoutData.find(el => el.shop_id === data.shop.id && el.product_sale_element_id === data.product_sale_element_id)?.destock_quantity
          : formDestockData.value.checkoutData.find(el => el.store_id === data.store.id && el.product_sale_element_id === data.product_sale_element_id)?.destock_quantity,
      totalQuantity: (!!data.shop_id
          ? productPlaces?.shops?.find(s => s.id === data.shop_id)?.stock
          : productPlaces?.stores?.find(s => s.id === data.store_id)?.stock) ?? 0
    })
  }
  // numberLocked.value = article.checkout_attributes.map(attr => ({ qtyToTake: 0 }));

  $('#editModal').modal('show');
};
const onlyNumber = ($event) => {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;

  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    $event.preventDefault();
  }
};
const modalAction = (index) => {
  numberLocked.value[index].qtyToTake = 0;
};
function toggleCreateModal() {
  $('#editModal').modal('toggle')
}
// Listes de référence (statuts, moyens de paiement) : elles ne changent pas, une fois suffit
let referenceDataLoaded = false

async function loadData() {
  const checkoutId = route.params?.id

  if (!referenceDataLoaded) {
    referenceDataLoaded = true
    store.dispatch('core/loadCheckoutStatus')
    store.dispatch('payments/loadPaymentStatusEnums')
    store.dispatch('payments/loadPaymentEnums')
  }

  await Promise.all([
    store.dispatch('ecommerce/getCheckout', checkoutId),
    store.dispatch('ecommerce/getCheckoutStatusHistories', checkoutId).then((response) => {
      statusHistories.value = response?.data
    }),
    store.dispatch('ecommerce/getCheckoutDeliveryNote', { checkout_id: checkoutId })
      .then((res) => { deliveryNote.value = res?.data })
      .catch(() => {}),
  ])
}
async function createDestockageData() {
  isLoading.value = true;
  let oldCheckoutWithoutThisProduct = formDestockData.value.checkoutData.filter(el => el.product_sale_element_id !== formEditModal.value.product_sale_element_id )
  let newProductData = []
  // null (pas '') pour le champ non concerné : côté backend,
  // whereNotNull('store_id') laisse passer une chaîne vide, et la
  // comparaison de collection qui suit traite ensuite null == '' comme
  // vraie — une ligne "boutique" pouvait alors percuter à tort le
  // traitement "entrepôt" et neutraliser l'ajustement de stock.
  formEditModal.value.destockage.forEach(el => {
    newProductData.push({
      product_sale_element_id: formEditModal.value.product_sale_element_id,
      shop_id: el.isShop ? el.place_id : null,
      shop_name: el.isShop ? el.place_name : null,
      store_id: el.isShop ? null : el.place_id ,
      store_name: el.isShop ? null : el.place_name ,
      destock_quantity:  el.quantity
    })
  })

  otherPlaces.value.forEach(el => {
    newProductData.push({
      product_sale_element_id: formEditModal.value.product_sale_element_id,
      shop_id: el.isShop ? el.place_id : null,
      shop_name: el.isShop ? el.place_name : null,
      store_id: el.isShop ? null : el.place_id ,
      store_name: el.isShop ? null : el.place_name ,
      destock_quantity:  el.quantity
    })
  })

  formDestockData.value.checkoutData = [...oldCheckoutWithoutThisProduct, ...newProductData]

  // Le bouton "Enregistrer" de ce modal ne faisait que mettre à jour le
  // formulaire en mémoire, sans jamais l'envoyer au serveur — le clic
  // n'avait donc visiblement aucun effet. On persiste immédiatement ici,
  // au lieu d'obliger à cliquer ensuite sur le bouton "Gérer le stock".
  try {
    await store.dispatch('ecommerce/setCheckoutDestockage', formDestockData.value)
    window.toastr['success'](i18n.global.t('notification.destock_success'))
    $('#editModal').modal('hide');
    await loadData()
  } catch (e) {
    window.toastr['error'](i18n.global.t('error'))
  } finally {
    isLoading.value = false;
  }
}
async function downloadPDF() {
  try {
    await store.dispatch('ecommerce/downloadDeliveryReceipt', route?.params?.id)
  } catch (error) {
    console.error('Échec du téléchargement du PDF :', error)

  }
}
function formatHandoverDate(value) {
  const d = new Date(value)
  return d.toLocaleDateString('fr-FR') + ' ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
}

// remise au client : le code de remise est demandé (commandes passées depuis la fonctionnalité)
const showHandover = ref(false)
const needsHandoverCode = (status) => status === 'DELIVERED' && !!checkout.value?.requires_handover_code

function submitHandover(handover) {
  const payload = { checkout_id: route?.params.id, status: 'DELIVERED', ...handover }
  return store.dispatch('ecommerce/updateCheckoutStatus', { ...payload, silent: true }).then(() => onStatusUpdated(payload))
}

function advanceStatus() {
  if (!nextStatus.value) return
  reassignMode.value = false
  formUpdateStatusData.value.status = nextStatus.value
  if (needsHandoverCode(nextStatus.value)) {
    showHandover.value = true
    return
  }
  if (nextStatus.value === 'SHIPPED') {
    // Passage à SHIPPED : ouvrir la modale pour permettre d'assigner un livreur
    $('#changeStatusModal').modal('toggle')
    return
  }
  updateCheckoutStatusData()
}

function resetDeliveryAssignment() {
  formUpdateStatusData.value.delivery_type = 'INTERNAL'
  formUpdateStatusData.value.delivery_user_id = ''
  formUpdateStatusData.value.delivery_person_name = ''
  formUpdateStatusData.value.delivery_person_phone = ''
  formUpdateStatusData.value.delivery_person_phone_code = ''
  selectedExternalDeliveryPersonId.value = ''
  assignDelivery.value = false
  showNewExternalPerson.value = false
}

watch(selectedExternalDeliveryPersonId, (personId) => {
  const person = externalDeliveryPersons.value.find(p => p.id === personId)
  if (person) {
    formUpdateStatusData.value.delivery_person_name = person.name
    formUpdateStatusData.value.delivery_person_phone = person.phone || ''
    formUpdateStatusData.value.delivery_person_phone_code = person.phone_code || ''
  }
})

function openManualStatusChange() {
  showManualStatusMenu.value = false
  reassignMode.value = false
  formUpdateStatusData.value.status = ''
  resetDeliveryAssignment()
  $('#changeStatusModal').modal('toggle')
}

function handleClickOutsideStatusMenu(event) {
  if (statusMenuRef.value && !statusMenuRef.value.contains(event.target)) {
    showManualStatusMenu.value = false
  }
}

// statut enregistré : affiché tout de suite, puis rechargement complet de la commande
function onStatusUpdated(payload) {
  // nouveau statut affiché tout de suite ; le rechargement complet (historique,
  // bon de livraison…) suit sans bloquer l'affichage
  if (checkout.value) {
    store.commit('ecommerce/' + ecommerceTypes.SET_CURRENT_ORDER, {
      checkout: {
        ...checkout.value,
        status: payload.status,
        ...(payload.status === 'DELIVERED' ? { payment_status: 'PAID' } : {}),
      },
      delivery_info: deliveryInfo.value,
    })
  }
  $('#changeStatusModal').modal('hide')
  window.toastr['success'](i18n.global.t('destockage.status_updated'))
  isUpdateStatusLoading.value = false
  formUpdateStatusData.value.status = ''
  resetDeliveryAssignment()
  loadData()
  store.dispatch('ecommerce/getExternalDeliveryPersons', { active_only: 1 }).then(response => {
    externalDeliveryPersons.value = response?.data || []
  })
}

// changement de livreur d'une commande en cours de livraison (même fenêtre, sans les statuts)
const reassignMode = ref(false)
const canChangeDriver = computed(() => checkout.value?.status === 'SHIPPED' && deliveryNote.value?.status !== 'DELIVERED')

function openChangeDriver() {
  resetDeliveryAssignment()
  reassignMode.value = true
  assignDelivery.value = true
  $('#changeStatusModal').modal('show')
}

function changeDriver() {
  const payload = {
    delivery_type: formUpdateStatusData.value.delivery_type,
    delivery_user_id: formUpdateStatusData.value.delivery_type === 'INTERNAL' ? formUpdateStatusData.value.delivery_user_id : null,
    delivery_person_name: formUpdateStatusData.value.delivery_type === 'EXTERNAL' ? formUpdateStatusData.value.delivery_person_name : null,
    delivery_person_phone: formUpdateStatusData.value.delivery_type === 'EXTERNAL' ? formUpdateStatusData.value.delivery_person_phone : null,
    delivery_person_phone_code: formUpdateStatusData.value.delivery_type === 'EXTERNAL' ? formUpdateStatusData.value.delivery_person_phone_code : null,
  }
  isUpdateStatusLoading.value = true
  window.axios.patch(`update/checkout/${route?.params.id}/delivery-person`, payload)
      .then((response) => {
        window.toastr.success(response.data.message)
        $('#changeStatusModal').modal('hide')
        reassignMode.value = false
        resetDeliveryAssignment()
        loadData()
      })
      .catch(() => {})
      .finally(() => { isUpdateStatusLoading.value = false })
}

function updateCheckoutStatusData() {
  if (reassignMode.value) {
    changeDriver()
    return
  }
  const payload = { ...formUpdateStatusData.value }
  if (needsHandoverCode(payload.status)) {
    $('#changeStatusModal').modal('hide')
    showHandover.value = true
    return
  }
  if (!assignDelivery.value) {
    payload.delivery_type = null
    payload.delivery_user_id = null
    payload.delivery_person_name = null
    payload.delivery_person_phone = null
    payload.delivery_person_phone_code = null
  } else if (payload.delivery_type === 'INTERNAL') {
    payload.delivery_person_name = null
    payload.delivery_person_phone = null
    payload.delivery_person_phone_code = null
    if (!payload.delivery_user_id) {
      payload.delivery_type = null
    }
  } else {
    payload.delivery_user_id = null
    if (!payload.delivery_person_name) {
      payload.delivery_type = null
    }
  }

  Swal.fire({
    title: i18n.global.t('destockage.swal_title'),
    text: i18n.global.t('destockage.swal_text'),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: i18n.global.t('swal.yes'),
    cancelButtonText: i18n.global.t('swal.no'),
  }).then((result) => {
    if (result.isConfirmed) {
      isUpdateStatusLoading.value = true
      store.dispatch('ecommerce/updateCheckoutStatus', payload)
          .then(() => onStatusUpdated(payload))
          .catch(() => {
            isUpdateStatusLoading.value = false
          })
    }
  })
}


async function submitDestockageData() {
  Swal.fire({
    title: i18n.global.t('swal.destock_confitmation'),
    text: i18n.global.t('swal.text'),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: i18n.global.t('swal.yes'),
    cancelButtonText: i18n.global.t('swal.no'),
  }).then( async (result) => {
    if (result.value) {
      // bouton en attente dès la confirmation : l'enregistrement puis le rechargement de la commande prennent un instant
      isLoading.value = true
      try {
        await store.dispatch('ecommerce/setCheckoutDestockage', formDestockData.value)
        window.toastr['success'](i18n.global.t('notification.destock_success'))
        await loadData()
      }catch (e) {
      } finally {
        isLoading.value = false
      }
    }
  });
}
const generateAttributeHTML = (checkoutAttributes) => {
  if (!checkoutAttributes) return '';
  return checkoutAttributes.map(el => `<span class="small fw-bolder">${el.attribute}</span>: <span class="small text-bold">${el.attribute_value}</span>`).join('|');
}

const getOtherShops = (checkoutShops = [], otherPlaces = [], currentIndex = 0) => {
  return [...checkoutShops.filter(el => !otherPlaces.some((place, index) => place?.place_id === el?.id && currentIndex != index))]
}
const addOtherDestockingPlace = () => {
  otherPlaces.value.push({
    place_id: "",
    place_name: "",
    isShop: true,
    quantity: "",
    totalAvailableQuantity: 0
  })
}

const selectOtherPlace = (otherPlace, val) => {
  let placeData = checkoutShops.value.find(el => el.id === val)
  otherPlace.isShop = placeData?.isShop
  otherPlace.place_name = placeData?.name
  otherPlace.totalAvailableQuantity = placeData?.stock ?? 0
}

const removeOtherDestockingPlace = (index) => {
  otherPlaces.value.splice(index, 1);
  otherPlaces.value = [...otherPlaces.value];
}

// Quand on navigue vers une autre commande depuis le panneau notifs,
// Vue Router réutilise ce composant sans le re-monter → on recharge explicitement.
watch(() => route.params.id, (newId, oldId) => {
  if (newId && newId !== oldId) {
    pageLoading.value = true
    loadData().finally(() => { pageLoading.value = false })
  }
})

onMounted(() => {
  initializeSelect()
  // la page s'affiche dès que la commande est chargée ; devise et livreurs suivent en arrière-plan
  pageLoading.value = true
  loadData().finally(() => { pageLoading.value = false })
  Promise.all([
    store.dispatch('shop/getCurrency').then(response => {
      currency.value = response?.data.currency_symbol ? response?.data.currency_symbol : response?.data.symbol_native
    }),
    store.dispatch('ecommerce/getUsersForDelivery').then(response => {
      deliveryUsers.value = response?.data || []
    }),
    store.dispatch('ecommerce/getExternalDeliveryPersons', { active_only: 1 }).then(response => {
      externalDeliveryPersons.value = response?.data || []
    }),
  ]).catch(() => {})
  document.addEventListener('click', handleClickOutsideStatusMenu)
})
onUpdated(() => {
  initializeSelect()
})
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutsideStatusMenu)
})

watch(() => formUpdateStatusData.value.status, (value) => {
  resetDeliveryAssignment()
  initializeSelect()
})
function initializeSelect(){
  KTApp.initSelect2()
  $(".kt_select2").select2()

  $(".kt_select2").change((e) => {
    switch (e.target.name) {
      case 'create_measure':
        formCreateData.value.measure_id = e.target.value
        break;
      case 'delivery_user':
        formUpdateStatusData.value.delivery_user_id = e.target.value
        break;
      case 'external_delivery_person':
        selectedExternalDeliveryPersonId.value = e.target.value
        break;
      default:
        break;
    }
  });
}
</script>

<style scoped>
/* historique compact */
.history-card .timeline-label .timeline-item { margin-bottom: 1.1rem; }
.history-card .timeline-label .timeline-label { width: 44px; font-size: 0.85rem !important; }
.history-card .timeline-label:before { left: 44px; }
.history-card .timeline-content { font-size: 0.85rem; line-height: 1.45; }
.history-card .timeline-content .fs-7 { font-size: 0.75rem !important; }
.history-card .timeline-badge .fs-1 { font-size: 1.4rem !important; }
.pickup-badge {
  background: #e8f1fd;
  color: #1e6fd9;
}
/* Destockage Card Styles */
.destockage-card {
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
}

.destockage-card .card-header {
  background: #fff;
  padding: 1.5rem 2rem;
}

.card-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Info Cards */
.info-card {
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.info-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Customer Section */
.customer-section {
  transition: all 0.3s ease;
}

.customer-section:hover {
  border-color: #3699FF !important;
  background-color: #f8f9fa;
}

/* Products Section */
.products-section .table thead tr {
  border-radius: 8px;
}

.products-section .table tbody tr {
  transition: all 0.2s ease;
}

.products-section .table tbody tr:hover {
  background-color: #f8f9fa;
}

/* Symbol */
.symbol-label {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Background colors */
.bg-light-primary { background-color: rgba(54, 153, 255, 0.1) !important; }

/* Button styles */
.btn-light-warning {
  background-color: rgba(255, 152, 0, 0.1);
  color: #FF9800;
  border: none;
}

.btn-light-warning:hover {
  background-color: rgba(255, 152, 0, 0.2);
  color: #e68900;
}

.btn-light-primary {
  background-color: rgba(54, 153, 255, 0.1);
  color: #3699FF;
  border: none;
}

.btn-light-primary:hover {
  background-color: rgba(54, 153, 255, 0.2);
  color: #0073e6;
}

.btn-icon {
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

/* Ribbon styles */
.ribbon {
  position: relative;
}

.ribbon.ribbon-top .ribbon-label {
  top: -5px;
  right: 20px;
  position: absolute;
  padding: 8px 15px;
  border-radius: 0 0 8px 8px;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  z-index: 10;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

/* Background colors for ribbon */
.bg-primary { background-color: #3699FF !important; }
.bg-success { background-color: #4CAF50 !important; }
.bg-warning { background-color: #FF9800 !important; }
.bg-danger { background-color: #F44336 !important; }
.bg-info { background-color: #00BCD4 !important; }
.bg-secondary { background-color: #6c757d !important; }

/* Text colors */
.text-primary { color: #3699FF !important; }
.text-success { color: #4CAF50 !important; }
.text-warning { color: #FF9800 !important; }
.text-danger { color: #F44336 !important; }
.text-info { color: #00BCD4 !important; }
.text-secondary { color: #6c757d !important; }

/* Quantity badge */
.qty-badge {
  font-weight: 500;
  font-size: 14px;
}

/* tuiles de statut du changement manuel */
.status-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.status-tile {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
  color: #3f4254;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.status-tile:hover:not(:disabled) {
  border-color: var(--kt-primary);
}
.status-tile.is-selected {
  border-color: var(--kt-primary);
  background: rgba(var(--kt-primary-rgb), 0.06);
  color: var(--kt-primary);
}
.status-tile:disabled {
  background: #f9f9f9;
  color: #a1a5b7;
  cursor: not-allowed;
}
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.status-label {
  flex: 1;
}
.status-current {
  font-size: 0.7rem;
  font-weight: 500;
}
.status-check {
  color: var(--kt-primary);
}
@media (max-width: 400px) {
  .status-grid { grid-template-columns: 1fr; }
}
</style>
